import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, NavController } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { BalanceModel } from 'src/app/models/balance-model';
import { CurrencyFormatterPipe } from 'src/app/pipes/currency-formatter/currency-formatter.pipe';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format.pipe';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { LimitsService } from 'src/app/services/limits/limits.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { SpendLimitService } from 'src/app/services/spend-limit/spend-limit.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';

@Component({
  selector: 'app-spend-limit',
  templateUrl: './spend-limit.component.html',
  styleUrls: ['./spend-limit.component.scss'],
})
export class SpendLimitComponent implements OnInit, AfterViewInit {
    @Input() previousPage: string = "";
    @ViewChild('scrollableContent', {  }) scrollableContent: ElementRef;

    private scrollContainer: any;

    ngAfterViewInit() {
        if(this.scrollContainer){
            this.scrollContainer = this.scrollableContent.nativeElement;
        }
            this.siteContentService.loadConfig('spend_limit')
            .then((response: SiteContentInterface) => {
            this.labels = response
            })
    }

    @ViewChild(IonContent, { static: false }) content: IonContent;
    public labels: SiteContentInterface;
    public error = null;

    public spendLimitsForm: FormGroup;

    public spend_daily_limit: AbstractControl;
    public spend_weekly_limit: AbstractControl;
    public spend_monthly_limit: AbstractControl;

    public dailyLimitError: boolean = false;
    public weeklyLimitError: boolean = false;
    public monthlyLimitError: boolean = false;

    public dailySpendLimits: any;
    public weeklySpendLimits: any;
    public monthlySpendLimits: any;

    public spendLimits: any[] = [];

    public globalDailyLimit: any;
    public globalWeeklyLimit: any;
    public globalMonthlyLimit: any;

    public globalLimits: any[] = [];

    private floatingPointValidator = "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$";
    public currency: any;

    constructor(
        private siteContentService: SiteContentService,
        public successMessageProvider: SuccessMessageService,
        public navCtrl: NavController,
        public utils: UtilsService,
        public navigator: Navigator,
        private spendLimitService : SpendLimitService,
        public currencyFormatterPipe: CurrencyFormatterPipe,
        public accountBalanceService: AccountBalanceService,
        public dateFormatPipe: DateFormatPipe,
        public limitsService: LimitsService
    ) {
        this.labels = new SiteContentModel();
        this.successMessageProvider.clearMessage();
        this.error = null;
    }

    ngOnInit() {
        this.spendLimitsForm = new FormGroup(
            {
                spend_daily_limit: new FormControl('', [Validators.pattern(this.floatingPointValidator)]),
                spend_weekly_limit: new FormControl('', [Validators.pattern(this.floatingPointValidator)]),
                spend_monthly_limit: new FormControl('', [Validators.pattern(this.floatingPointValidator)])
            },  this.atLeastOneFieldValidator
        );

        this.spend_daily_limit = this.spendLimitsForm.get('spend_daily_limit');
        this.spend_weekly_limit = this.spendLimitsForm.get('spend_weekly_limit');
        this.spend_monthly_limit = this.spendLimitsForm.get('spend_monthly_limit');

        this.getGlobalLimits();
        this.getSpendLimits();

        // we need to get currency
        this.accountBalanceService.getBalance().subscribe((response: BalanceModel) =>{
            this.currency = response.getDefaultCurrency();
        });
    }
    getTopOffset(controlEl: HTMLElement): number {
        const labelOffset = 50;
        return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
    }
    getGlobalLimits() {
        this.spendLimitService.getGlobalLimits().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.globalLimits = response.payload.filter((limit) => {
                        return limit.limitType == "WAGER";
                    });


                    this.globalLimits.forEach((limit) => {
                        if (limit.limitTermType == "DAILY") {
                            this.globalDailyLimit = limit.currentLimit;
                            this.spend_daily_limit.setValidators([Validators.pattern(this.floatingPointValidator), Validators.max(this.globalDailyLimit)]);
                        }
                        else if (limit.limitTermType == "WEEKLY") {
                            this.globalWeeklyLimit = limit.currentLimit;
                            this.spend_weekly_limit.setValidators([Validators.pattern(this.floatingPointValidator), Validators.max(this.globalWeeklyLimit)]);
                        }
                        else if (limit.limitTermType == "MONTHLY") {
                            this.globalMonthlyLimit = limit.currentLimit;
                            this.spend_monthly_limit.setValidators([Validators.pattern(this.floatingPointValidator), Validators.max(this.globalMonthlyLimit)]);
                        }
                    });
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    getSpendLimits() {
        let tempLimits: any[] = [];

        this.spendLimitService.getSpendLimit().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    tempLimits = response.payload;


                    for (const index in tempLimits) {
                        if (tempLimits[index].limitSource != "GLOBAL") {
                            this.spendLimits.push(tempLimits[index]);
                        }
                    }

                    this.updateSpendLimits(this.spendLimits);
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    updateSpendLimits(spendLimits: any[]) {
        this.spend_daily_limit.setValue("");
        this.spend_weekly_limit.setValue("");
        this.spend_monthly_limit.setValue("");

        this.spend_daily_limit.markAsPristine();
        this.spend_weekly_limit.markAsPristine();
        this.spend_monthly_limit.markAsPristine();

        for (const i in spendLimits) {
            if (spendLimits[i] != null) {
                if (spendLimits[i].currentLimitTermType == "DAILY") {
                    this.dailySpendLimits = spendLimits[i];
                }

                if (spendLimits[i].currentLimitTermType == "WEEKLY") {
                    this.weeklySpendLimits = spendLimits[i];
                }

                if (spendLimits[i].currentLimitTermType == "MONTHLY") {
                    this.monthlySpendLimits = spendLimits[i];
                }
            }
        }
    }

    deleteLimit(term: string) {

        this.successMessageProvider.clearMessage();
        this.error = null;

        const requestObj: any = {};
        requestObj.termType = term.toUpperCase();

        this.spendLimitService.deleteSpendLimit(requestObj).subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.getSpendLimits();
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    setLimits( ) {
        this.successMessageProvider.clearMessage();
        this.error = null;

        this.spendLimitService.setSpendLimit(this.spendLimitsForm.value).subscribe({
            next: (response: any) => {
                if (response && !!response.result ) {
                    this.getSpendLimits();

                    this.successMessageProvider.setMessage('Your spend limits were set.');
                    this.content.scrollToTop(10);
                }
            },
            error: (error) => {

                switch (error.getErrorCode().toUpperCase()) {
                    case 'INVALID_TERM_TYPE':
                        error.setErrorMessage('Limit cannot be 0!');
                        break;
                    default:
                        error.setErrorMessage('');
                        break;
                }
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    onLimitChanged(term) {
        console.log('limitChanged');
        if(term.toUpperCase() == "DAILY") {
            this.dailyLimitChanged();
        } else if(term.toUpperCase() == "WEEKLY") {
            this.weeklyLimitChanged();
        } else if(term.toUpperCase() == "MONTHLY") {
            this.monthlyLimitChanged();
        }
    }

    dailyLimitChanged() {
        if (this.globalDailyLimit != null) {
            this.dailyLimitError = parseInt(this.spend_daily_limit.value) > parseInt(this.globalDailyLimit);
        }
    }

    weeklyLimitChanged() {
        if (this.globalWeeklyLimit != null) {
            this.weeklyLimitError = parseInt(this.spend_weekly_limit.value) > parseInt(this.globalWeeklyLimit);
        }
    }

    monthlyLimitChanged() {
        if (this.globalMonthlyLimit != null) {
            this.monthlyLimitError = parseInt(this.spend_monthly_limit.value) > parseInt(this.globalMonthlyLimit);
        }
    }

    atLeastOneFieldValidator(group: FormGroup): {[key: string]: any} {
        let isAtLeastOne = false;
        if (group && group.controls) {
            for (const control in group.controls) {
                if (Object.prototype.hasOwnProperty.call(group.controls, control) && group.controls[control].valid && group.controls[control].value) {
                    isAtLeastOne = true;
                    break;
                }
            }
        }
        return isAtLeastOne ? null : { 'required': true };
    }

    onClose = () =>{
        this.limitsService.onCloseCommon(this.previousPage == "SignupResult");
    }

    enterPressed() {
        if(!this.spendLimitsForm.invalid) {
            this.setLimits();
        }
    }
}
